import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { message } from 'antd';
import { List } from 'components/Page';
import {
  clear, dirty, list, remove, reset
} from 'actions';

/**
 * @description Map data and server flight
 * @param {state} Object
 */
const mapStateToProps = (state, ownProps) => ({
  item: state.api[ownProps.reducer.item.key].data,
  results: ownProps.config.format ? ownProps.config.format(state.api[ownProps.reducer.list.key].data.results) : state.api[ownProps.reducer.list.key].data.results,
  totalRecords: state.api[ownProps.reducer.list.key].data.count,
  inFlight: state.api[ownProps.reducer.list.key].inFlight,
  isDirty: state.api[ownProps.reducer.list.key].isDirty
});

/**
 * @description Dispatch create, loadList, load, deleteItem
 * @param {dispatch} Object
 */
const mapDispatchToProps = (dispatch, ownProps) => ({
  clearErrors() {
    dispatch(clear(ownProps.reducer.item.key));
  },
  resetItem() {
    return dispatch(reset(ownProps.reducer.item.key));
  },
  loadList(params) {
    dispatch(list(
      ownProps.reducer.list.key, params
    ));
  },
  reloadList() {
    dispatch(dirty(ownProps.reducer.list.key));
  },
  deleteItem(id) {
    return dispatch(remove(ownProps.reducer.item.key, { id }));
  }
});
/**
 * Single
 * @description Single View
 * @version 1.0.0
 */
const Table = ({
  canAdmin,
  classes,
  config,
  clearErrors,
  deleteItem,
  isDirty,
  item,
  results,
  inFlight,
  loadList,
  messaging,
  reloadList,
  resetItem,
  themeName,
  totalRecords,
  ...rest
}) => {
  /**
   * @description Delete the item and dislpay a relevant message
   * @param {id} Number
   * @triggers {reloadList}
   */
  const handleDelete = (id) => {
    deleteItem(id)
      .then((response) => {
        if (response.status === 204) {
          message.success(messaging.delete.success());
          resetItem(); // remove item data from store
        }
        else {
          message.success(messaging.delete.disabled());
        }
        reloadList(); // reload the list of items to reflect the changes in related  data
      })
      .catch((error) => {
        message.error(messaging.delete.failure(error));
      });
  };
  // Layout Component to build out the Page
  return (
    <div className={classNames(classes, 'bhp-container')}>
      <List
        canAdmin={canAdmin}
        className={classNames(config.classes, classes, 'bhp-container')}
        dataSource={results}
        isDirty={isDirty}
        inFlight={inFlight}
        onLoadList={loadList}
        onDeleteItem={handleDelete}
        onLoad={resetItem}
        selectedItemId={item.id}
        totalRecords={totalRecords}
        {...config}
        {...rest}
      />
    </div>
  );
};

Table.propTypes = {
  canAdmin: PropTypes.bool,
  classes: PropTypes.string,
  config: PropTypes.object,
  clearErrors: PropTypes.func,
  deleteItem: PropTypes.func,
  isDirty: PropTypes.bool,
  item: PropTypes.object,
  results: PropTypes.array,
  inFlight: PropTypes.bool,
  loadList: PropTypes.func,
  messaging: PropTypes.object,
  resetItem: PropTypes.func,
  reloadList: PropTypes.func,
  themeName: PropTypes.string,
  totalRecords: PropTypes.number
};

Table.defaultProps = {
  canAdmin: false,
  classes: '',
  clearErrors() {
  },
  config: {},
  deleteItem() {
  },
  isDirty: false,
  item: {},
  results: [],
  inFlight: false,
  loadList() {
  },
  messaging: {
    delete: {
      disabled: () => 'Item Disabled.',
      failure: error => `Delete Failed. ${error}`,
      success: () => 'Delete Successful.'
    }
  },
  resetItem() {
  },
  reloadList() {
  },
  themeName: '',
  totalRecords: 0
};

export default connect(mapStateToProps, mapDispatchToProps)(Table);
